export const getStorage = (key) => {
    if(typeof window !== 'undefined'){

        if(sessionStorage.getItem('useSession')) {
            return sessionStorage.getItem(key);
        }

        return localStorage.getItem(key);
    }
    return null;
}

export const setStorage = (key, value) => {
    if(typeof window !== 'undefined'){

        if(sessionStorage.getItem('useSession')) {
            if(!value) {
                sessionStorage.removeItem(key);
                return;
            }
            sessionStorage.setItem(key, value);
            return;
        }

        if(!value) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, value)
    }
}
